import { addDays, format } from 'date-fns';
import { trackPromise } from 'react-promise-tracker';
import { IGerenciadorPrecosDatapoint } from '../../../../../@types';
import { IPAMaths, api } from '../../../../../lib';
import { withPendingEditedPrice } from '../../../../../store/priceManagerStore';
import { GET_ITEMS_FAMILY_CLUSTER_MODAL_PARAMS, GET_ITEMS_FAMILY_CLUSTER_MODAL_RESPONSE, UpdateProductDataDTO } from './types';

export const transformItem = (item: IGerenciadorPrecosDatapoint): IGerenciadorPrecosDatapoint => {
  const { price, competitorsPrice, retailPrice, cost, salesTaxPercentage, expensesPercent } = item;

  const novaCompetitividade = IPAMaths.novaCompetitividade(price, competitorsPrice as number);

  const retailCpi = IPAMaths.novaCompetitividade(retailPrice, competitorsPrice as number);

  return {
    ...item,
    expirationDate: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
    revenueForecastSevenDays: 13000,
    novaMargem: IPAMaths.novaMargem(price, salesTaxPercentage, expensesPercent, cost),
    novaCompetitividade,
    retailCpi,
  };
};

export const GET_ITEMS_FAMILY_CLUSTER_MODAL = async ({ sort, page, size, ...data }: GET_ITEMS_FAMILY_CLUSTER_MODAL_PARAMS = {}) => {
  const response = await trackPromise(
    api.post<GET_ITEMS_FAMILY_CLUSTER_MODAL_RESPONSE>('/all-products/modal', data, {
      expectToken: true,
      params: {
        sort,
        page,
        size,
      },
    }),
  );
  return { ...response.data, content: response.data.content.map(transformItem) };
};

export const UPDATE_FAMILY_CLUSTER_PRICES = async (data: UpdateProductDataDTO) => {
  return withPendingEditedPrice(() =>
    trackPromise(
      api({
        url: `${process.env.REACT_APP_IPA_URL}/all-products/update/price/modal-products`,
        method: 'POST',
        expectToken: true,
        data,
      }).then(resp => resp),
      'update-product-price-family-modal',
    ),
  );
};
